/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DuplicateBuiltInDashboardRequestBody,
  DuplicateBuiltInDashboardRequestBody$Outbound,
  DuplicateBuiltInDashboardRequestBody$outboundSchema,
} from "../components/duplicatebuiltindashboardrequestbody.js";

export type DuplicateBuiltInDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DuplicateBuiltInDashboardRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  duplicateBuiltInDashboardRequestBody: DuplicateBuiltInDashboardRequestBody;
};

/** @internal */
export type DuplicateBuiltInDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DuplicateBuiltInDashboardSecurity$outboundSchema: z.ZodMiniType<
  DuplicateBuiltInDashboardSecurity$Outbound,
  DuplicateBuiltInDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function duplicateBuiltInDashboardSecurityToJSON(
  duplicateBuiltInDashboardSecurity: DuplicateBuiltInDashboardSecurity,
): string {
  return JSON.stringify(
    DuplicateBuiltInDashboardSecurity$outboundSchema.parse(
      duplicateBuiltInDashboardSecurity,
    ),
  );
}

/** @internal */
export type DuplicateBuiltInDashboardRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DuplicateBuiltInDashboardRequestBody:
    DuplicateBuiltInDashboardRequestBody$Outbound;
};

/** @internal */
export const DuplicateBuiltInDashboardRequest$outboundSchema: z.ZodMiniType<
  DuplicateBuiltInDashboardRequest$Outbound,
  DuplicateBuiltInDashboardRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    duplicateBuiltInDashboardRequestBody:
      DuplicateBuiltInDashboardRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      duplicateBuiltInDashboardRequestBody:
        "DuplicateBuiltInDashboardRequestBody",
    });
  }),
);

export function duplicateBuiltInDashboardRequestToJSON(
  duplicateBuiltInDashboardRequest: DuplicateBuiltInDashboardRequest,
): string {
  return JSON.stringify(
    DuplicateBuiltInDashboardRequest$outboundSchema.parse(
      duplicateBuiltInDashboardRequest,
    ),
  );
}
